'use client';

import type { ReverseProposalGoodsItem } from '@musinsa/services-curator';
import type { HTMLAttributes, ReactNode } from 'react';
import { ProductInformationPrimitive } from '../../../common';
import { ProductShell } from './ProductShell';

interface ReverseProposalProductProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  item: ReverseProposalGoodsItem;
  checked?: boolean;
  index?: number;
  children?: ReactNode;
  imageClassName?: string;
  informationClassName?: string;
  informmationChildren?: ReactNode;
  onClickCheckbox?: () => void;
  onClickCloseButton?: () => void;
  onClickLikeButton?: (item: ReverseProposalGoodsItem, nextIsLiked: boolean) => void;
  /** 29cm 딥링크 활성화 여부 */
  enableDeeplink?: boolean;
  callbackClick?: (item: ReverseProposalGoodsItem) => void;
  callbackImpression?: (item: ReverseProposalGoodsItem) => void;
}

export const ReverseProposalProduct = ({
  className,
  item,
  checked,
  index,
  children,
  imageClassName,
  informationClassName,
  informmationChildren,
  onClickCheckbox,
  onClickCloseButton,
  onClickLikeButton,
  enableDeeplink = false,
  callbackClick,
  callbackImpression,
  ...rest
}: ReverseProposalProductProps) => {
  const infoBlock = (
    <ProductInformationPrimitive.Container className={informationClassName}>
      <div>
        <ProductInformationPrimitive.BrandName brandName={item.brandName} />
        <ProductInformationPrimitive.GoodsName goodsName={item.goodsName} />
      </div>

      <div className="flex flex-col">
        <ProductInformationPrimitive.DiscountPriceRow
          finalPrice={item.price}
          finalDiscount={item.salesRate ?? 0}
        />
      </div>

      {informmationChildren && (
        <ProductInformationPrimitive.Footer>
          {informmationChildren}
        </ProductInformationPrimitive.Footer>
      )}
    </ProductInformationPrimitive.Container>
  );

  // NOTE: ReverseProposalGoodsItem은 URL 필드가 없음 — callbackClick으로 navigate 처리
  return (
    <ProductShell
      className={className}
      item={item}
      checked={checked}
      index={index}
      imageClassName={imageClassName}
      infoBlock={infoBlock}
      onClickCheckbox={onClickCheckbox}
      onClickCloseButton={onClickCloseButton}
      onClickLikeButton={onClickLikeButton}
      enableDeeplink={enableDeeplink}
      callbackClick={callbackClick}
      callbackImpression={callbackImpression}
      {...rest}
    >
      {children}
    </ProductShell>
  );
};
